import React, {useEffect, useState, useRef} from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import CompanyHeader from "components/CompanyHeader";
import CompanySideMenu from "components/CompanySideMenu";
import ChatList from "./components/ChatList";
import ChatBox from "./components/ChatBox";
import {
  getListChatCompany, getListTalentRecommend,
  setChatSelected, setChatList, setLoadingGetListChat,
  setIsChatting, setIsPaging, setIsSameChatSelected,
  setIsScout, setJobSelected, setMessages, setTalentSelected,
  getNumberMessages, getMessages, getDetailTalentChat,
  getListJobRecommend, setIsNewChatFormOtherScreen, setIsNewChat,
  getActions, setActionItems, setAction, setActionStatus,
  setIsDiscardUnsentMessagePopup, setPendingPath, setTextInput,
  setIsMessageFormDirty, setIsNewCompanyConversation,
  setFiles, setGlobalFilterString, setIsFlagFilter,
} from "reducers/chatMessage";
import { getListOptionsRelatedAction } from "reducers/action";
import {useDispatch, useSelector} from "react-redux";
import {ThunkDispatch} from "@reduxjs/toolkit";
import CustomButton from "../../components/CustomButton";
import CustomIconButton from "../../components/CustomIconButton";
import Copyright from "../../components/Copyright";
import TextInput from "../../components/TextInput";
import ConfirmPopup from "../../components/ConfirmPopup";
import {formatPadStartNumber} from "utils/format";
import UnsaveConfirmPopup from "../action/components/UnsaveConfirmPopup";

const ChatManagement = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const navigate = useNavigate();
  const location = useLocation();
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  let {staffInfo} = useSelector((state: any) => state.currentUser)
  const { chatList, chatSelected, isChatting, actionStatus, actionName, isNewChatFormOtherScreen,
  pageSize, totalCons, isSameChatSelected, messages, isDiscardUnsentMessagePopup, textInput,
  isScout, pendingPath, globalFilterString, pageSizeLoadingJobRec, isMessageFormDirty, 
  isSuccess, isNewCompanyConversation, isFlagFilter } = useSelector((state: any) => state.chatMessage);
  const { optionsRelatedAction } = useSelector((state: any) => state.action);
  const divRef = useRef<HTMLDivElement | null>(null);
  const [page, setPage] = useState(1);
  const [filterString, setFilterString] = useState(
    globalFilterString && (globalFilterString + "").trim()
      ? (/^\d*$/.test(globalFilterString.trim())
          ? formatPadStartNumber(globalFilterString.trim(), 6)
          : globalFilterString.trim())
      : ""
  );
  const isFromHome = location.state?.isFromHome;

  useEffect(() => {
    const handleScroll = () => {
      if (divRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = divRef.current;
        if (scrollTop + clientHeight + 20 >= scrollHeight && page * pageSize < totalCons) {
          dispatch(setIsPaging(true))
          const nextPage = page + 1
          dispatch(setLoadingGetListChat(true))
          dispatch(getListChatCompany({page: nextPage, pageSize: pageSize, filter: filterString, isFlag: isFlagFilter}));
          setPage(nextPage)
        }
      }
    };

    const divElement = divRef.current;
    divElement?.addEventListener("scroll", handleScroll);

    return () => divElement?.removeEventListener("scroll", handleScroll);
  }, [page, chatList]);

  useEffect(() => {
    setIsFirstLoad(true)
    dispatch(setIsPaging(false))

    let filterStr = ""
    if(globalFilterString && (globalFilterString + "").trim()) {
      if (/^\d*$/.test(globalFilterString)) {
        filterStr = formatPadStartNumber(globalFilterString, 6)
      } else {
        filterStr = globalFilterString
      }
    }
    setFilterString(filterStr)
    dispatch(getListChatCompany({page: 1, pageSize: pageSize, filter: filterStr, isFlag: isFlagFilter}));
  }, [globalFilterString]);

  useEffect(() => {
    // Get list talent recommend
    const data = { search: '' }
    dispatch(getListTalentRecommend(data));

    // Get list options related action
    if(optionsRelatedAction.action_status?.length == 0 || optionsRelatedAction.staffs?.length == 0) {
      dispatch(getListOptionsRelatedAction(""));
    }
  }, []);

  // Show toast
  useEffect(() => {
    if (actionStatus === 'fulfilled') {
      switch(actionName) {
          case 'sendMessage':
            if(!isSuccess) {
              break;
            }
            dispatch(setIsPaging(false))
            dispatch(setLoadingGetListChat(true))
            dispatch(getListChatCompany({page: 1, pageSize: page * pageSize, filter: filterString, isFlag: isFlagFilter}));
            dispatch(setIsNewChatFormOtherScreen(false));
            setIsFirstLoad(true)
            dispatch(setActionStatus('idle'));
            scrollToTop();
            break;
          case 'getListChatCompany':
            if (chatSelected?.id && !isNewChatFormOtherScreen) {
              const currentInList = chatList?.find((item: any) => item.id === chatSelected.id);
              if (currentInList) {
                dispatch(setChatSelected(currentInList));
              } else {
                dispatch(setJobSelected({}));
                dispatch(setChatSelected({}));
                dispatch(setTalentSelected({}));
                dispatch(setIsNewCompanyConversation(false));
                dispatch(setIsChatting(false));
              }
            } else if (
              (chatList?.length > 0 && !isNewChatFormOtherScreen && isSameChatSelected && chatSelected?.id) ||
              (chatList?.length > 0 && isNewCompanyConversation && !chatSelected?.id)
            ) {
              dispatch(setJobSelected({}));
              dispatch(setChatSelected({}));
              dispatch(setTalentSelected({}));
              handleSelectConvention(chatList[0]);
              dispatch(setIsNewCompanyConversation(false));
            }
            setIsFirstLoad(false)
            dispatch(setIsNewChatFormOtherScreen(false));
            dispatch(setActionStatus('idle'));
            break;
          case 'getMessages':
            dispatch(getNumberMessages(""));
            dispatch(setActionStatus('idle'));
            break;
          case 'updateConventionJob':
            dispatch(setIsPaging(false))
            dispatch(setLoadingGetListChat(true))
            dispatch(setIsSameChatSelected(false))
            dispatch(getListChatCompany({page: 1, pageSize: page * pageSize, filter: filterString, isFlag: isFlagFilter}));
            dispatch(setActionStatus('idle'));
            break;
          case 'updateConventionIsFlag':
            dispatch(setIsPaging(false))
            dispatch(setLoadingGetListChat(true))
            dispatch(setIsSameChatSelected(false))
            dispatch(getListChatCompany({page: 1, pageSize: page * pageSize, filter: filterString, isFlag: isFlagFilter}));
            dispatch(setActionStatus('idle'));
            break;
          default:
            break;
      }
    }
  }, [actionStatus, actionName, isSameChatSelected, messages]);

  const scrollToTop = () => {
    setTimeout(() => {
      if (divRef.current) {
        divRef.current.scrollTo({
          top: 0,
        });
      }
    }, 300); // Delay to render
  };

  const handleSelectConvention = (item: any) => {
    dispatch(setIsNewChat(false));
    dispatch(setIsChatting(true));
    dispatch(setIsNewChatFormOtherScreen(false));
    dispatch(setChatSelected(item));
    if (item?.talent && item?.talent?.id) {
      dispatch(setTalentSelected(item));
      dispatch(getDetailTalentChat({ id: item?.talent?.id }));

      // Get list job recommend
      const dataJob = { search: '', talentId: item?.talent?.id, pageSize: pageSizeLoadingJobRec }
      dispatch(getListJobRecommend(dataJob));
    }

    if(item?.job && item?.job.id) {
      dispatch(setIsScout(true));
      dispatch(setJobSelected(item?.job));
    } else {
      dispatch(setIsScout(false));
      dispatch(setJobSelected({}));
    }
    dispatch(getMessages({ id: item?.id }));

    // Get list actions
    dispatch(getActions({ chatConversationId: item?.id }));

    // Update readed
    let newChatList = JSON.parse(JSON.stringify(chatList));
    for(let itemChat of newChatList) {
      if(itemChat.id == item?.id) {
        if(itemChat?.user_chat && itemChat?.user_chat?.reads && !itemChat?.user_chat?.reads.includes(staffInfo.user_id)) {
          itemChat?.user_chat?.reads?.push(staffInfo.user_id)
        }
        break
      }
    }
    dispatch(setChatList(newChatList));
  };

  const setNewChat = () => {
    if(isMessageFormDirty) {
      dispatch(setIsDiscardUnsentMessagePopup(true));
      return;
    };
    setIsFirstLoad(true)
    dispatch(setIsChatting(true));
    dispatch(setIsNewChat(true));
    dispatch(setIsNewChatFormOtherScreen(false));
    dispatch(setIsScout(false));
    dispatch(setChatSelected({}));
    dispatch(setTalentSelected({}));
    dispatch(setJobSelected({}));
    dispatch(setMessages([]));
    dispatch(setActionItems([]));
    dispatch(setAction({}));
  }

  const handleConfirmDiscardUnsentMessage = () => {
    dispatch(setIsNewChat(true));
    dispatch(setIsScout(false));
      dispatch(setIsSameChatSelected(false));
      dispatch(setChatSelected({}));
      dispatch(setTalentSelected({}));
      dispatch(setJobSelected({}));
      dispatch(setMessages([]));
      dispatch(setPendingPath(""));
      dispatch(setTextInput(""));
      dispatch(setFiles([]));
      dispatch(setIsDiscardUnsentMessagePopup(false));
      dispatch(setIsMessageFormDirty(false));
  
      if (pendingPath) {
        navigate(pendingPath, { state: { isFromDetail: isFromHome ? false : true } });
      }
    }

  const redirectToTalentList = () => {
    if(isMessageFormDirty && !isDiscardUnsentMessagePopup) {
      dispatch(setIsDiscardUnsentMessagePopup(true));
      dispatch(setPendingPath('/company/talent'));
    } else {
      dispatch(setIsSameChatSelected(false));
      dispatch(setChatSelected({}));
      dispatch(setTalentSelected({}));
      dispatch(setJobSelected({}));
      dispatch(setMessages([]));
      dispatch(setTextInput(""));
      navigate('/company/talent', { state: { isFromDetail: isFromHome ? false : true } });
    }
  }

  const fetchListChat = (inputFilter: any, flagFilter?: boolean) => {
    const page = 1;
    dispatch(setIsPaging(false))
    setPage(1);
    const currentFlag = flagFilter !== undefined ? flagFilter : isFlagFilter;
    dispatch(getListChatCompany({page: 1, pageSize: pageSize, filter: inputFilter ? inputFilter.trim() : inputFilter, isFlag: currentFlag}));
  }

  const handleToggleFlagFilter = () => {
    const nextFlag = !isFlagFilter;
    dispatch(setIsFlagFilter(nextFlag));
    fetchListChat(filterString, nextFlag);
  };

  const handeFilterMessage = (event: any) => {
    if (event.key === "Enter") {
      fetchListChat(filterString);
      dispatch(setGlobalFilterString(filterString));
    }
  };

  return (
    <>
      <CompanyHeader />
      <div className="mt-6 px-6 flex gap-6 relative">
        <CompanySideMenu />
        <div className="flex-1 flex gap-1 max-h-[calc(100dvh-100px)]">
          <div className="max-w-[30rem] sm:min-w-auto md:min-w-[320px] lg:min-w-[380px] xl:min-w-[450px] max-h-full w-[450px]">
            <div className="flex items-center mb-4 pl-4">
              <CustomIconButton
                variant="icononly"
                customStyle="shrink-0 !w-6 !h-6 mr-2"
                onClick={handleToggleFlagFilter}
                aria-label={isFlagFilter ? "フラグ絞り込みを解除" : "フラグ付きチャットで絞り込む"}
                aria-pressed={isFlagFilter}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <mask id="mask_chat_header_flag" style={{maskType: "alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                    <rect width="24" height="24" fill="#D9D9D9"/>
                  </mask>
                  <g mask="url(#mask_chat_header_flag)">
                    <path
                      d={isFlagFilter
                        ? "M5 22V3H21L19 8L21 13H7V22H5Z"
                        : "M5 22V3H21L19 8L21 13H7V22H5ZM7 11H18.05L16.85 8L18.05 5H7V11Z"}
                      fill={isFlagFilter ? "#FF861A" : "#BBBBBB"}
                    />
                  </g>
                </svg>
              </CustomIconButton>
              <div className="w-[9.625rem] mr-2">
                <TextInput
                  id="filter"
                  name="filter"
                  value={filterString}
                  onChange={(e:any) => setFilterString(e.target.value)}
                  onClearQuery={() => {
                    dispatch(setGlobalFilterString(""));
                    setFilterString("");
                    fetchListChat("");
                  }}
                  onKeyDown={(e:any) => handeFilterMessage(e)}
                  placeholder="名前 / ID"
                  searchIcon={true}
                />
              </div>
              <span className="mr-2 w-[1px] h-8 bg-[#E0E0E0]"></span>
              <CustomButton
                customStyle="mr-2"
                disabled={isChatting && !chatSelected.id}
                onClick={setNewChat}
                type="button"
                variant="outline"
                size="md"
              >
                新規作成
              </CustomButton>
              <CustomButton
                onClick={redirectToTalentList}
                variant="text"
                type="button"
                size="md"
              >
                タレント一覧
              </CustomButton>
            </div>

            <div ref={divRef} className="bg-white p-2 rounded-l-lg h-[calc(100dvh-200px)] overflow-y-auto overflow-x-hidden custom-scrollbar">
              <ChatList />
            </div>
          </div>

          <div className="w-full max-h-[calc(100dvh-145px)] overflow-y-visible custom-scrollbar">
            <ChatBox />
          </div>
        </div>
      </div>
      <Copyright view="company" />
      {isDiscardUnsentMessagePopup && <UnsaveConfirmPopup
        open={isDiscardUnsentMessagePopup}
        onClose={() => dispatch(setIsDiscardUnsentMessagePopup(false))}
        confirmContent={"編集中の内容を保存せずに終了しますか？"}
        onOtherAction={handleConfirmDiscardUnsentMessage}
      />}
    </>
  );
};

export default ChatManagement;